import React from "react";
const Spinner = () => <div className="spinner-backdrop"><div className="pos-center"><div className="controlled-loader"></div></div></div>;

export default Spinner;
